/**
 * What the recorder does when a take ends (spec 13.7). Pure, for unit tests.
 *
 * - 'save': the coach pressed Save. The take is handed over, the recorder
 *   stays open on the same segment, ready to record again.
 * - 'save-and-leave': Save from the alert after Back (and the desktop's Save
 *   & Close). The take is handed over and the recorder closes; the coach
 *   asked to leave.
 * - 'discard': nothing is handed over; the recorder stays open.
 * - 'unplanned': the take stopped without the coach choosing anything (the
 *   recorder stopped itself, or was torn down). On a phone the take is kept
 *   and the recorder stays open; this was how a take could drop the coach
 *   back in the editor. The desktop keeps its old behaviour, save and close.
 *
 * Nothing here can change the route: the recorder has no router, and the
 * only way out is `close`.
 */
export type TakeEnd = 'save' | 'save-and-leave' | 'discard' | 'unplanned';

export interface TakeOutcome {
  /** Hand the take over: keeping the recorder open, or closing it. */
  handOver: 'stay' | 'close' | 'none';
  closeRecorder: boolean;
}

export function takeOutcome(end: TakeEnd, phone: boolean): TakeOutcome {
  switch (end) {
    case 'save': return { handOver: 'stay', closeRecorder: false };
    case 'save-and-leave': return { handOver: 'close', closeRecorder: true };
    case 'discard': return { handOver: 'none', closeRecorder: false };
    case 'unplanned': return phone ? { handOver: 'stay', closeRecorder: false } : { handOver: 'close', closeRecorder: true };
  }
}
